import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { FileText } from 'lucide-react';
import { get } from '@/api/client';
import { PostCard, type Post } from '@/components/organisms/PostCard';
import { Skeleton } from '@/components/atoms/Skeleton';
import { EmptyState } from '@/components/atoms/EmptyState';

export function UserPostsPage() {
  const { userId } = useParams<{ userId: string }>();

  const { data, isLoading } = useQuery({
    queryKey: ['users', userId, 'posts'],
    queryFn: () => get<{ posts: Post[] }>(`/users/${userId}/posts`),
    enabled: !!userId,
  });

  return (
    <div className="container-base py-10">
      <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-surface)] p-6 sm:p-8">
        <header className="mb-6">
          <h1 className="text-3xl font-extrabold">작성 글</h1>
          <p className="mt-2 text-sm text-[var(--color-text-sub)]">
            이 유저가 작성한 게시글 모음이에요.
          </p>
        </header>

        {isLoading && (
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="h-24 w-full rounded-xl" />
            ))}
          </div>
        )}

        {data?.posts && data.posts.length > 0 ? (
          <div className="space-y-3">
            {data.posts.map((p) => (
              <PostCard key={p.id} post={p} showBoard />
            ))}
          </div>
        ) : (
          !isLoading && (
            <EmptyState
              icon={FileText}
              title="작성한 글이 없어요"
              description="이 유저가 게시글을 작성하면 여기에 모아 보여드릴게요."
            />
          )
        )}
      </div>
    </div>
  );
}
